module.exports = __webpack_public_path__ + "static/FirebirdPort.98adb41d.jpg";